import { Skeleton } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";
import { useContractorsNavigationPages } from "./hooks";

type Props = {
  contractorId?: string;
};
export const NavigationContractors = observer(function NavigationContractors({
  contractorId,
}: Props) {
  const { visiblePages, data } = useContractorsNavigationPages(contractorId);
  const { isDesktop } = useScreenType();

  return (
    <AppSubNav>
      {visiblePages.map((page) => (
        <NavBar.Item key={page.href.pathname} href={page.href} active={false}>
          {page.title()}
        </NavBar.Item>
      ))}

      {isDesktop && contractorId && <Icon name="chevron-right" />}

      {contractorId && (
        <NavBar.Item
          href={{
            pathname: "/contractors/detail",
            query: {
              id: contractorId,
            },
          }}
          active={false}
        >
          <Skeleton isLoaded={!!data?.legal_name}>
            {data?.legal_name ?? t`Detail`}
          </Skeleton>
        </NavBar.Item>
      )}
    </AppSubNav>
  );
});
